import { Grid, HStack, Stack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { OverflowButton } from '$/components/common/OverflowButton';
import { type User } from '$/services/usecases/authentication/mapper/genericCloudResponse';

interface Props {
  student: User;
  onEdit: (student: User) => void;
  onDelete: (student: User) => void;
  className?: string;
}

export const StudentCard: FC<Props> = ({
  onEdit,
  onDelete,
  student,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Grid
      alignItems='center'
      templateColumns='minmax(0, 1.5fr) minmax(0, 0.5fr) minmax(0, 0.5fr) minmax(0, 1.5fr)'
      w='full'
      px='6'
      py='4'
      border='1px solid'
      borderColor='border'
      borderRadius='md'
    >
      <Stack gap='0'>
        <Text color='lighterText' fontSize='md'>
          {student.email}
        </Text>
        <Text fontSize='md' fontWeight='bold'>
          {student.firstname} {student.lastname}
        </Text>
      </Stack>
      <Text>{className ?? '-'}</Text>
      <Text>
        {student.expirationDate
          ? dayjs(student.expirationDate).format('YYYY-MM-DD')
          : '-'}
      </Text>
      <HStack justifyContent='flex-end'>
        <OverflowButton
          px='6'
          fontSize='sm'
          leftIcon={<Icon icon='edit_pen' w='14px' />}
          onClick={() => onEdit(student)}
          variant='tertiary'
        >
          {t('general.edit')}
        </OverflowButton>
        <OverflowButton
          px='6'
          fontSize='sm'
          leftIcon={<Icon icon='trash_can' w='14px' />}
          onClick={() => onDelete(student)}
          variant='tertiary'
          hideTextOnOverflow
        >
          {t('general.delete')}
        </OverflowButton>
      </HStack>
    </Grid>
  );
};
